/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSubtractScalar } from '../../factoriesAny.js';
export var subtractScalarDependencies = {
  typedDependencies,
  createSubtractScalar
};